import { Button, styled } from '@mui/material';
import { CustomizeIcon } from '@side/pantry';
import NextLink from 'next/link';
import { TXM_CUSTOMIZE_HOME_PATH } from '@/constants';
import {
  TrackHomePageEvent,
  useTrackHomePageAnalytics,
} from '$analytics/useTrackAnalytics/domains/homePage';

const StyledNextLink = styled(NextLink)`
  color: ${({ theme }) => theme.palette.primary.main};
  text-decoration: none;
`;

export const CustomizeButton = () => {
  const trackEvent = useTrackHomePageAnalytics();

  return (
    <Button
      startIcon={<CustomizeIcon sx={{ width: { xs: '16px', sm: '20px' } }} />}
      LinkComponent={StyledNextLink}
      href={TXM_CUSTOMIZE_HOME_PATH}
      onClick={() => {
        trackEvent(TrackHomePageEvent.CustomizeHomePageButtonClick);
      }}
      sx={{ px: 1 }}
    >
      Customize Your View
    </Button>
  );
};
